<script lang="ts">
  import { session } from '../../../lib/auth.svelte';
  import { tenantCtx } from '../../../lib/tenant.svelte';
  import { effectiveOrgTipo } from '../../../lib/clinic-preview.svelte';
  import VetClinicDashboard from './VetClinicDashboard.svelte';
  import OpticaClinicDashboard from './OpticaClinicDashboard.svelte';
  import ClinicaMedicaDashboard from './ClinicaMedicaDashboard.svelte';
  import ClinicPlusModules from '../widgets/ClinicPlusModules.svelte';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  const org = $derived(
    effectiveOrgTipo(
      tenantCtx.orgTipo as import('../../../lib/navigation').OrgTipo | null,
      tenantCtx.isHospitalEdition,
      session.value?.tenantId,
    ),
  );
</script>

<ClinicPlusModules {onNavigate} />

{#key org ?? 'default'}
  {#if org === 'clinica-veterinaria'}
    <VetClinicDashboard {onNavigate} />
  {:else if org === 'clinica-optica'}
    <OpticaClinicDashboard {onNavigate} />
  {:else}
    <ClinicaMedicaDashboard {onNavigate} />
  {/if}
{/key}
